<script>
const models = window.models

import { selection, activeStep } from './lib.js';

if(!$selection.chosenPaintGen) {
    $selection.chosenPaintGen = $selection.paints[0];
}

if(!$selection.chosenPaint) {
    $selection.chosenPaint = $selection.chosenPaintGen.options[0];
}
</script>
<h2 class="byo-heading -interior">Choose Your Exterior Paint Scheme</h2>
<img class="exterior" src="{$selection.chosenPaint.image}" alt="" />

<div class="model-slider__details -byo"><h3 class="model-slider__label -byo">Select a Color</h3> 
    {#if $selection.paints.length > 1} 
        <ul class="model-slider__gen-buttons">
        {#each $selection.paints as gen}
            <li class="model-slider__gen-item"><button on:click={() => { $selection.chosenPaintGen = gen; $selection.chosenPaint = gen.options[0]; }} aria-label="View color scheme options for Generation 4" class="button white-button -border-fill model-slider__gen-button js-button-text {$selection.chosenPaintGen == gen ? '-is-active' : ''}">{ gen.name }</button></li>
        {/each}
        </ul>
    {/if}
    <div class="model-slider__button-wrap">
        {#each $selection.chosenPaintGen.options as paint}
            <button on:click={() => { $selection.chosenPaint = paint }} class="model-slider__button -byo {paint == $selection.chosenPaint ? 'selected' : ''}">
            <img src="{paint.swatch}" alt="{paint.name}" class="model-slider__swatch">
        </button>
        {/each}
    </div>
    <span class="model-slider__color-name">{$selection.chosenPaint.name}</span>
    <p class="model-slider__disclaimer">Images shown are representations of paint layouts only and do not reflect all exterior features or options. Colors shown may slightly differ from colors on actual product.</p>
</div>



<div class="continue-bar js-continue-bar -active">
    <button class="continue-bar__text button -back js-forward" on:click="{() => { $activeStep = 0; window.scrollTo(0,0);}}">Prev</button>
    <button class="continue-bar__text button -forward js-forward" on:click="{() => { $activeStep = 2; window.scrollTo(0,0);}}">Next</button>
</div>

<style>
.exterior {
    max-width: 1200px;
    height: auto;
    margin: 0 auto;
    display: block;
}

@media (max-width: 1200px) {
    .exterior {
        max-width: 94%;
    }
}

.model-slider__button.-byo.selected::after {
	font-family: icomoon;
	font-size: 1rem !important;
	font-weight: 400;
	line-height: 0;
	font-style: normal;
	content: "";
	display: inline-block;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	width: 2rem;
	height: 2rem;
	background: #0b0b0b;
	border-radius: 50%;
	bottom: 0;
	color: #fff;
	line-height: 2em;
	position: absolute;
	right: -.5rem;
    top: auto;
}

.model-slider__button {
    box-sizing: content-box;
    padding: 0;
    outline: 0;
}

.model-slider__gen-item button {
    background: #fff !important;
    color: #000 !important;

    &.-is-active {
        background: #000 !important;
        color: #fff !important;
    }
}

</style>
